/* Velalune — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.vl-reveal:not(.vl-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vl-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vl-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCounters() {
    var els = document.querySelectorAll('[data-vl-count]');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-vl-count')) || 0;
      var dec = (String(target).split('.')[1] || '').length;
      if (reduce) { el.textContent = target.toFixed(dec); return; }
      var start = null, dur = 1600;
      function step(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(dec);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initBeforeAfter() {
    document.querySelectorAll('.vl-ba__slider').forEach(function (s) {
      if (s.dataset.vlReady) return; s.dataset.vlReady = '1';
      var range = s.querySelector('.vl-ba__range');
      if (!range) return;
      function set(v) { s.style.setProperty('--vl-pos', v + '%'); }
      range.addEventListener('input', function () { set(range.value); });
      set(range.value);
    });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-vl-parallax]');
    if (!els.length || reduce || window.innerWidth < 990) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-vl-parallax')) || 0;
        var r = el.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * k * -0.01;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  function initGallery() {
    document.querySelectorAll('.vl-gal').forEach(function (g) {
      if (g.dataset.vlReady) return; g.dataset.vlReady = '1';
      var main = g.querySelector('.vl-gal__main img');
      g.querySelectorAll('.vl-gal__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          g.querySelectorAll('.vl-gal__thumb').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          main.style.opacity = 0;
          setTimeout(function () {
            main.src = t.getAttribute('data-src');
            main.removeAttribute('srcset');
            main.alt = t.getAttribute('data-alt') || '';
            main.style.opacity = 1;
          }, 180);
        });
      });
    });
  }

  function initGaleriaMovil() {
    document.querySelectorAll('[data-vl-gal-slider]').forEach(function (slider) {
      if (slider.dataset.vlReady) return; slider.dataset.vlReady = '1';
      var dots = slider.parentElement.querySelector('[data-vl-gal-dots]');
      var imgs = [].slice.call(slider.children);
      if (!dots || imgs.length < 2) return;
      imgs.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Foto ' + (i + 1));
        if (i === 0) b.className = 'is-active';
        b.addEventListener('click', function () { imgs[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); });
        dots.appendChild(b);
      });
      var t;
      slider.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var centro = slider.scrollLeft + slider.clientWidth / 2;
          var activo = 0, mejor = Infinity;
          imgs.forEach(function (img, i) {
            var c = img.offsetLeft + img.clientWidth / 2;
            if (Math.abs(c - centro) < mejor) { mejor = Math.abs(c - centro); activo = i; }
          });
          [].slice.call(dots.children).forEach(function (b, i) { b.classList.toggle('is-active', i === activo); });
        }, 80);
      }, { passive: true });
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-vl-product]').forEach(function (root) {
      if (root.dataset.vlReady) return; root.dataset.vlReady = '1';
      var dataEl = root.querySelector('script[data-vl-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var fieldsets = root.querySelectorAll('.vl-pdp__opt');
      if (!fieldsets.length) return;
      function update() {
        var sel = [];
        fieldsets.forEach(function (fs) {
          var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
        });
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        var btns = root.querySelectorAll('[data-vl-buy]');
        root.querySelectorAll('input[name="id"]').forEach(function (i) { if (v) i.value = v.id; });
        root.querySelectorAll('[data-vl-price]').forEach(function (e) { e.innerHTML = v ? v.price : ''; });
        root.querySelectorAll('[data-vl-compare]').forEach(function (e) { e.innerHTML = v && v.compare ? v.compare : ''; e.hidden = !(v && v.compare); });
        root.querySelectorAll('[data-vl-save]').forEach(function (e) { e.innerHTML = v && v.save ? v.save : ''; e.hidden = !(v && v.save); });
        btns.forEach(function (b) {
          var ok = v && v.available;
          b.disabled = !ok;
          if (!b.dataset.label) b.dataset.label = b.textContent;
          b.textContent = ok ? b.dataset.label : (b.getAttribute('data-soldout') || 'Agotado');
        });
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    });
  }

  function initAcordeon() {
    document.querySelectorAll('[data-vl-acc]').forEach(function (grupo) {
      if (grupo.dataset.vlReady) return; grupo.dataset.vlReady = '1';
      grupo.querySelectorAll('.vl-acc__head').forEach(function (head) {
        head.addEventListener('click', function () {
          var item = head.parentElement;
          var abierto = item.classList.contains('is-open');
          grupo.querySelectorAll('.vl-acc__item.is-open').forEach(function (otro) {
            otro.classList.remove('is-open');
            var h = otro.querySelector('.vl-acc__head');
            if (h) h.setAttribute('aria-expanded', 'false');
          });
          if (!abierto) {
            item.classList.add('is-open');
            head.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  function initCombo() {
    document.querySelectorAll('[data-vl-combo]').forEach(function (form) {
      if (form.dataset.vlReady) return; form.dataset.vlReady = '1';
      var toggle = form.querySelector('[data-vl-combo-toggle]');
      var extras = form.querySelectorAll('[data-vl-combo-extra]');
      var total = form.querySelector('[data-vl-combo-total]');
      var tachados = form.querySelector('[data-vl-combo-tachados]');
      var ahorro = form.querySelector('[data-vl-combo-ahorro]');
      var eti = form.querySelector('[data-vl-combo-eti]');
      function sync() {
        var on = toggle.checked;
        extras.forEach(function (e) { e.disabled = !on; });
        if (total) total.textContent = on ? total.dataset.junto : total.dataset.solo;
        if (eti) eti.textContent = on ? eti.dataset.junto : eti.dataset.solo;
        if (tachados) tachados.hidden = !on;
        if (ahorro) ahorro.hidden = !on;
      }
      toggle.addEventListener('change', sync);
      sync();
    });
  }

  /* --- Barra de envío gratis: se actualiza al instante --- */
  function vlFormatoDinero(centavos, formato) {
    var n = centavos / 100;
    function sep(valor, decimales, milesConComa) {
      var s = valor.toFixed(decimales);
      var partes = s.split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, milesConComa ? ',' : '.');
      return decimales ? partes.join(milesConComa ? '.' : ',') : partes[0];
    }
    var m = (formato || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, clave) {
      switch (clave) {
        case 'amount': return sep(n, 2, true);
        case 'amount_no_decimals': return sep(n, 0, true);
        case 'amount_with_comma_separator': return sep(n, 2, false);
        case 'amount_no_decimals_with_comma_separator': return sep(n, 0, false);
        case 'amount_with_space_separator': return sep(n, 2, true).replace(/,/g, ' ');
        case 'amount_no_decimals_with_space_separator': return sep(n, 0, true).replace(/,/g, ' ');
        case 'amount_with_apostrophe_separator': return sep(n, 2, true).replace(/,/g, "'");
        default: return sep(n, 2, true);
      }
    });
    return m.replace(/\.00(?!\d)/, '').replace(/,00(?!\d)/, '');
  }

  function vlPintaEnvio(carrito) {
    document.querySelectorAll('[data-vl-envio]').forEach(function (barra) {
      var umbral = parseInt(barra.dataset.umbral, 10) || 0;
      if (!umbral) return;
      var total = carrito.total_price || 0;
      var falta = umbral - total;
      var pct = Math.min(Math.round((total * 100) / umbral), 100);
      var txt = barra.querySelector('[data-vl-envio-txt]');
      var riel = barra.querySelector('[data-vl-envio-riel]');
      var up = barra.querySelector('[data-vl-envio-up]');
      var ico = barra.querySelector('[data-vl-envio-ico]');
      barra.classList.toggle('is-ok', falta <= 0);
      if (riel) riel.style.width = pct + '%';
      if (txt) {
        txt.textContent = falta > 0
          ? (barra.dataset.textoFalta || '').replace('[falta]', vlFormatoDinero(falta, barra.dataset.formato))
          : (barra.dataset.textoOk || '');
      }
      if (ico) {
        var esCheck = falta <= 0;
        var yaCheck = ico.dataset.estado === 'ok';
        if (esCheck !== yaCheck) {
          ico.dataset.estado = esCheck ? 'ok' : 'falta';
          ico.innerHTML = esCheck
            ? '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 10.5l3.2 3.2L15 6.5"/></svg>'
            : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>';
        }
      }
    });
  }

  function vlRefrescaEnvio() {
    if (!document.querySelector('[data-vl-envio]')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(vlPintaEnvio)
      .catch(function () {});
    // el bloque de sugerencia lo arma el servidor: lo volvemos a pedir
    fetch('/cart?section_id=main-cart-items')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nueva = doc.querySelector('.vl-envio-up');
        document.querySelectorAll('.vl-envio-barra').forEach(function (barra) {
          var vieja = barra.querySelector('.vl-envio-up');
          if (nueva && vieja) vieja.replaceWith(nueva.cloneNode(true));
          else if (nueva && !vieja) barra.appendChild(nueva.cloneNode(true));
          else if (!nueva && vieja) vieja.remove();
        });
      })
      .catch(function () {});
  }

  function initEnvio() {
    if (window.__vlEnvioListo) { vlRefrescaEnvio(); return; }
    window.__vlEnvioListo = true;
    var fetchOriginal = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var p = fetchOriginal.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(vlRefrescaEnvio, 60); }).catch(function () {});
      }
      return p;
    };
    document.addEventListener('change', function (e) {
      if (e.target.closest('cart-items, cart-drawer-items, #main-cart-items, .cart-drawer')) setTimeout(vlRefrescaEnvio, 300);
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('cart-remove-button, .cart-remove-button, quantity-input button')) setTimeout(vlRefrescaEnvio, 400);
    });
    vlRefrescaEnvio();
  }

  /* --- Carrusel de opiniones: bucle infinito sin huecos --- */
  function initOpiniones() {
    document.querySelectorAll('.vl-op__track--auto').forEach(function (track) {
      var wrap = track.parentElement;
      if (!track.dataset.vlBase) {
        var base = [].slice.call(track.children).filter(function (el) { return !el.hasAttribute('aria-hidden'); });
        if (!base.length) base = [].slice.call(track.children);
        track.dataset.vlBase = base.map(function (el) { return el.outerHTML; }).join('');
        track.dataset.vlNum = base.length;
      }
      function montar() {
        var estilo = getComputedStyle(track);
        var gap = parseFloat(estilo.columnGap || estilo.gap) || 0;
        track.style.animation = 'none';
        track.innerHTML = track.dataset.vlBase;
        var tarjetas = [].slice.call(track.children);
        var anchoBase = tarjetas.reduce(function (s, el) { return s + el.getBoundingClientRect().width + gap; }, 0);
        if (!anchoBase) return;
        var necesario = (wrap.getBoundingClientRect().width || window.innerWidth) * 1.6;
        var copias = Math.max(1, Math.ceil(necesario / anchoBase));
        var mitad = '';
        for (var i = 0; i < copias; i++) mitad += track.dataset.vlBase;
        track.innerHTML = mitad + mitad;
        [].slice.call(track.children).forEach(function (el, i) {
          if (i >= copias * parseInt(track.dataset.vlNum, 10)) el.setAttribute('aria-hidden', 'true');
        });
        var ajuste = parseFloat(track.dataset.vlSpeed) || 60;
        var anchoMitad = anchoBase * copias;
        var velocidad = 2400 / ajuste; // px por segundo (ajuste 60 = 40 px/s)
        track.style.animation = '';
        track.style.animationDuration = Math.round(anchoMitad / velocidad) + 's';
      }
      track.dataset.vlSpeed = parseFloat(getComputedStyle(track).animationDuration) || 60;
      montar();
      var t;
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(montar, 250); });
    });
  }

  function initCarritoLateral() {
    if (window.__vlDrawerListo) return;
    window.__vlDrawerListo = true;
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      var btn = e.submitter;
      var quiere = form.hasAttribute('data-vl-drawer') || (btn && btn.hasAttribute('data-vl-cart'));
      var cajon = document.querySelector('cart-drawer');
      if (!quiere || !cajon || typeof cajon.renderContents !== 'function') return;
      e.preventDefault();
      var fd = new FormData(form);
      fd.delete('return_to');
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
      if (btn) btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections) {
            cajon.classList.remove('is-empty');
            cajon.renderContents(data);
          } else {
            window.location.href = '/cart';
          }
          setTimeout(vlRefrescaEnvio, 100);
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
  }

  function initSticky() {
    var bar = document.querySelector('.vl-sticky');
    var target = document.querySelector('[data-vl-sticky-anchor]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past);
      });
    });
    io.observe(target);
  }

  function initAll() {
    initReveal(); initCounters(); initBeforeAfter(); initParallax(); initGallery(); initGaleriaMovil(); initVariants(); initAcordeon(); initCombo(); initEnvio(); initOpiniones(); initCarritoLateral(); initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
